import { useEffect, useState } from "react";
import { DashLayout } from "@/components/DashLayout";
import { TxTable } from "@/components/Tables";
import { WalletFilter } from "@/components/WalletFilter";
import { api } from "@/lib/api";
import { ADMIN_NAV } from "@/pages/navs";

export default function AdminTransactions() {
  const [wallet, setWallet] = useState("all");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/admin/transactions", { params: wallet === "all" ? {} : { wallet } }).then((r) => setRows(r.data));
  }, [wallet]);

  return (
    <DashLayout nav={ADMIN_NAV} title="All Transactions" subtitle="Ledger across all merchants">
      <WalletFilter value={wallet} onChange={setWallet} />
      <TxTable rows={rows} showUser />
    </DashLayout>
  );
}
